<script setup lang="ts">
defineProps({
  isActiveStep: {
    type: Boolean,
    required: true,
  },
  hideStepIndicator: {
    type: Boolean,
    default: false,
  },
})
</script>
<template>
  <li
    :aria-current="isActiveStep ? 'step' : false"
    class="step flex w-full max-w-[816px] items-baseline border-b-2 border-b-portal-indigo-100 py-16 <sm:pr-8 last:border-0"
  >
    <div
      v-if="!hideStepIndicator"
      :class="`${
        isActiveStep
          ? 'bg-[--theme-medium] text-white'
          : 'bg-[--theme-lighter] text-[--theme-darkest]'
      } mr-12 flex items-center justify-center rounded-full font-national2compressed font-bold lg:min-h-16 lg:min-w-16 lg:text-3xl <md:mr-4 <lg:min-h-10 <lg:min-w-10 <lg:text-2xl`"
    >
      <slot name="step" />
    </div>
    <div>
      <h2
        class="mb-6 font-numeraWebRegular text-[32px] leading-relaxed text-[--theme-darkest] <md:mb-4 <md:text-[24px]"
      >
        <slot name="title" />
      </h2>
      <slot name="content" />
    </div>
  </li>
</template>

<style scoped lang="postcss"></style>
